import React from 'react';
import { Add as AddIcon, FileDownload as ExportIcon } from '@mui/icons-material';
import { useOrdersPermissions } from '../../../../hooks/useOrdersPermissions';
import { useOrdersActionButtons } from './OrdersActionButtons.hooks';
import {
  ActionButtonsContainer,
  ButtonsRow,
  CreateOrderButton,
  ExportButton,
} from './OrdersActionButtons.styles';

/** Oculto por ahora: export de Gestión de Ventas no es necesario. */
const SHOW_SALES_ORDERS_EXPORT = false;

interface OrdersActionButtonsProps {
  onCreateOrder: () => void;
  onExport: () => void;
}

const OrdersActionButtons: React.FC<OrdersActionButtonsProps> = ({ onCreateOrder, onExport }) => {
  const { canAdd } = useOrdersPermissions();
  const { handleCreateOrder, handleExport } = useOrdersActionButtons({
    onCreateOrder,
    onExport,
  });

  return (
    <ActionButtonsContainer>
      <ButtonsRow>
        {canAdd && (
          <CreateOrderButton
            variant="contained"
            startIcon={<AddIcon />}
            size="small"
            onClick={handleCreateOrder}
          >
            Nueva Venta
          </CreateOrderButton>
        )}

        {SHOW_SALES_ORDERS_EXPORT && (
          <ExportButton
            variant="outlined"
            startIcon={<ExportIcon />}
            size="small"
            onClick={handleExport}
          >
            Exportar
          </ExportButton>
        )}
      </ButtonsRow>
    </ActionButtonsContainer>
  );
};

export default OrdersActionButtons;
